import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9243840c"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_2 = /*#__PURE__*/_createTextVNode("搜索")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("重置")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("确认无误")
const _hoisted_5 = /*#__PURE__*/_createTextVNode("拒绝")
const _hoisted_6 = /*#__PURE__*/_createTextVNode("重新收款")
const _hoisted_7 = /*#__PURE__*/_createTextVNode("取消")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("确定")

import { ref, reactive, onBeforeMount, computed, nextTick } from 'vue'
import { ElMessage, ElMessageBox } from 'element-plus'
import tbMix from '@/global_mixin/tableMixin'
import { baddebtMap, baddebtOrderMap } from '@/views/typeMapping/Financial'
import { formatNumber, getNumber } from '@/utils/index'
import Api from '@/http/modules/index'

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const {
  'POST/bad_debt/sale/confirmed/query': fetchList,
  // 坏账_确认坏账_重新收款
  'POST/bad_debt/sale/recharge': rechargeApi,
  // 坏账_待收款订单_确认坏账
  'POST/bad_debt/finance/declare_bad_debt': declare_bad_debtApi,
  // 坏账_确认坏账
  'POST/bad_debt/sale/confirmed': confirmedApi,
} = Api

let seleRows = ref([])
const { 
  MI_tableData, fetchData, page, size, MI_total, MI_pageChange,
  MI_sizeChange, MI_identify, MI_params, MI_height
} = new tbMix(fetchList)

const searchEle = ref()
const searchObj = reactive({
  owner: '', customer: '', orderNo: '', extraDays: undefined,
})
const searchHandle = () => {
  fetchData(searchObj)
}
searchHandle()

// 确认
const confirmHandle = (row: any) => {
  ElMessageBox.prompt('', '请输入确认原因', {
    inputPattern:
      /\S/,
    inputErrorMessage: '请输入确认原因',
  }).then(({value}) => {
    MI_identify.value = true
    return confirmedApi({
      confirmType: 0,
      orderId: row.orderId,
      idList: row.list.map((e: {id: number}) => e.id),
      reason: value
    })
  }).then(() => {
    MI_identify.value = false
    ElMessage.success('确认成功')
    searchHandle()
  }).finally(() => {
    MI_identify.value = false
  })
}

// 拒绝
const isShowReject = ref<boolean>(false)
const rejectObj = reactive({
  reason: '', confirmType: 1, idList: []
})
const showReject = (row: any) => {
  const {orderId, id} = row
  Object.assign(rejectObj, {orderId, idList: [id], reason: ''})
  isShowReject.value = true
}
const submitReject = () => {
  if(rejectObj.reason.length === 0){
    ElMessage.warning('请输入拒绝原因')
    return
  }
  confirmedApi(rejectObj).then(() => {
    ElMessage.success('已拒绝')
    isShowReject.value = false
    searchHandle()
  })
}


// 重新收款
const recollectionHandle = (row: {id: number}) => {
  ElMessageBox.confirm('请确认是否重新收款', '提示', {type: 'warning'}).then(() => {
    MI_identify.value = true
    return rechargeApi({id: row.id})
  }).then(() => {
    MI_identify.value = false
    ElMessage.success('成功')
    searchHandle()
  }).finally(() => {
    MI_identify.value = false
  })
}

const mergeMethod = ({row, columnIndex}: any) => {
  if (row.list) {
    if (columnIndex === 0) {
      return [1, 18]
    } else if(columnIndex <= 17) {
      return [0, 0]
    }
  }
}

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_collapse_item = _resolveComponent("el-collapse-item")!
  const _component_el_collapse = _resolveComponent("el-collapse")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_space = _resolveComponent("el-space")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_collapse, { class: "mb-10" }, {
      default: _withCtx(() => [
        _createVNode(_component_el_collapse_item, { title: "搜索" }, {
          default: _withCtx(() => [
            _createVNode(_component_el_form, {
              ref_key: "searchEle",
              ref: searchEle,
              model: _unref(searchObj),
              inline: "",
              class: "searchBg",
              disabled: _unref(MI_identify)
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "订单号:",
                  prop: "orderNo"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).orderNo,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(searchObj).orderNo) = $event)),
                      clearable: "",
                      maxlength: "100",
                      placeholder: "请输入订单号",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户名称:",
                  prop: "customer"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).customer,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_unref(searchObj).customer) = $event)),
                      clearable: "",
                      maxlength: "100",
                      placeholder: "请输入客户名称",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_form_item, {
                  label: "客户经理:",
                  prop: "owner"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: _unref(searchObj).owner,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(searchObj).owner) = $event)),
                      clearable: "",
                      maxlength: "100",
                      placeholder: "请输入客户经理",
                      class: "form-input"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _hoisted_1,
                _createVNode(_component_el_form_item, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_button, {
                      onClick: _cache[3] || (_cache[3] = ($event: any) => (searchHandle())),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_2
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_button, {
                      onClick: _cache[4] || (_cache[4] = ($event: any) => {searchEle.value.resetFields(); _unref(searchObj).extraDays = undefined})
                    }, {
                      default: _withCtx(() => [
                        _hoisted_3
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["model", "disabled"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _withDirectives((_openBlock(), _createBlock(_component_el_table, {
      ref: "tb",
      border: "",
      data: _unref(MI_tableData),
      onSelectionChange: _cache[5] || (_cache[5] = (rows) => _isRef(seleRows) //@ts-ignore
 ? seleRows.value = rows : seleRows = rows),
      "row-class-name": ({row}: any) => row.list ? 'gray-row' : '',
      "max-height": _unref(MI_height) - 80 + 'px',
      class: "mt-10",
      "row-key": "id",
      "tree-props": { children: 'list' },
      "default-expand-all": "",
      "header-row-class-name": () => 'gray-head',
      "expand-row-keys": [_unref(MI_tableData)[0]?.id + ''],
      "span-method": mergeMethod
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          label: "",
          prop: "",
          width: "100",
          fixed: ""
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row.list ? `${row.name}(${row.sale})【${row.list[0].isEnforced ? '强制': '非强制'}】` : ''), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "订单号",
          prop: "no",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "订单名称",
          prop: "name",
          "show-overflow-tooltip": ""
        }, {
          default: _withCtx(({row}) => [
            _createTextVNode(_toDisplayString(row.list ? '' : row.name), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          label: "客户ID",
          prop: "customerUsername",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户名称",
          prop: "customer",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户联系人",
          prop: "customerContactor",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "客户经理",
          prop: "owner",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          label: "币种",
          prop: "currency",
          width: "100"
        }),
        _createVNode(_component_el_table_column, {
          label: "金额",
          prop: "amount",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          label: "本位币",
          prop: "standardMoney",
          align: "right",
          formatter: _unref(formatNumber)
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "startTime",
          label: "开始日期",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "deliverTime",
          label: "交付日期",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "status",
          label: "订单状态",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          prop: "confirmStatus",
          label: "处理状态",
          formatter: (row) => _unref(baddebtMap)()[row.confirmStatus],
          width: "100"
        }, null, 8, ["formatter"]),
        _createVNode(_component_el_table_column, {
          prop: "reason",
          label: "原因",
          "show-overflow-tooltip": ""
        }),
        _createVNode(_component_el_table_column, {
          prop: "operationName",
          label: "操作人"
        }),
        _createVNode(_component_el_table_column, {
          prop: "lastModifiedTime",
          label: "操作日期",
          width: "130"
        }),
        _createVNode(_component_el_table_column, {
          prop: "createTime",
          label: "发起确认坏账时间",
          width: "120"
        }),
        _createVNode(_component_el_table_column, {
          label: "操作",
          fixed: "right",
          width: "180"
        }, {
          default: _withCtx(({row}) => [
            _createVNode(_component_el_space, { wrap: "" }, {
              default: _withCtx(() => [
                (row.list && row.list.some((e) => e.confirmStatus === 'CONFIRMATION_UNCONFIRMED'))
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 0,
                      onClick: ($event: any) => (confirmHandle(row)),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_4
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (row.isEnforced === false && row.confirmStatus === 'CONFIRMATION_UNCONFIRMED')
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 1,
                      onClick: ($event: any) => (showReject(row)),
                      type: "danger"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_5
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (['CONFIRMATION_CONFIRMED'].includes(row.confirmStatus))
                  ? (_openBlock(), _createBlock(_component_el_link, {
                      key: 2,
                      onClick: ($event: any) => (recollectionHandle(row)),
                      type: "primary"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_6
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1024)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data", "row-class-name", "max-height", "header-row-class-name", "expand-row-keys"])), [
      [_directive_loading, _unref(MI_identify)]
    ]),
    _createVNode(_component_el_pagination, {
      total: _unref(MI_total),
      background: "",
      small: "",
      "page-size": _unref(size),
      "onUpdate:page-size": _cache[6] || (_cache[6] = ($event: any) => (_isRef(size) ? (size).value = $event : null)),
      currentPage: _unref(page),
      "onUpdate:currentPage": _cache[7] || (_cache[7] = ($event: any) => (_isRef(page) ? (page).value = $event : null)),
      "page-sizes": [30, 50, 100, 300],
      class: "mt-10",
      disabled: _unref(MI_identify),
      layout: "sizes, prev, pager, next, total, jumper",
      onCurrentChange: _unref(MI_pageChange),
      onSizeChange: _unref(MI_sizeChange)
    }, null, 8, ["total", "page-size", "currentPage", "disabled", "onCurrentChange", "onSizeChange"]),
    _createVNode(_component_el_dialog, {
      modelValue: isShowReject.value,
      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((isShowReject).value = $event)),
      title: "提示",
      width: "450"
    }, {
      footer: _withCtx(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (isShowReject.value = false))
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: _cache[10] || (_cache[10] = ($event: any) => (submitReject()))
        }, {
          default: _withCtx(() => [
            _hoisted_8
          ]),
          _: 1
        })
      ]),
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _unref(rejectObj).reason,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(rejectObj).reason) = $event)),
          placeholder: "请输入拒绝原因",
          type: "textarea",
          rows: 5
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})